import { render } from "./PetsBannerComponent.vue?vue&type=template&id=7aa2b7c0&scoped=true"
import script from "./PetsBannerComponent.vue?vue&type=script&lang=js"
export * from "./PetsBannerComponent.vue?vue&type=script&lang=js"

import "./PetsBannerComponent.vue?vue&type=style&index=0&id=7aa2b7c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa2b7c0"]])

export default __exports__